import React, { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { ROLES } from '../config/constants';
import PetOwnerDelivery from './Pet Owner/Delivery';
import AdminDelivery from './Admin/Delivery';

const Delivery = () => {
    const { user, roles, permission, updateContext } = useContext(UserContext);

    if (roles.includes(ROLES.ADMIN)) {
        return <AdminDelivery user={user} roles={roles} />;
    } else if (roles.includes(ROLES.USER)) {
        return <PetOwnerDelivery user={user} permission={permission} roles={roles} updateContext={updateContext} />;
    } else {
        return <></>
    }
};

export default Delivery;
